import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromPromise';
import type { FeatureStatus } from '@atlassian/jira-servicedesk-common/src/service-project-features/types.tsx';
import { performPostRequest } from '@atlassian/jira-servicedesk-common/src/utils/fetch/requests.tsx';

type UpdateFeatureResult = {
	feature: string;
	status: FeatureStatus;
	editable: boolean;
};

const updateFeatureService = (
	projectKey: string,
	feature: string,
	enable: boolean,
): Observable<UpdateFeatureResult> =>
	Observable.fromPromise(
		performPostRequest(
			`/rest/servicedesk/1/servicedesk/${projectKey}/features/${enable ? 'enable' : 'disable'}`,
			{ body: JSON.stringify({ feature }) },
		),
	);

export default updateFeatureService;
